const UserAdTypes = {
  LIST_INITING: 'USERAD.LIST_INITING',
  LOAD_USERS: 'USERAD.LOAD_USERS',
  SET_USERS: 'USERAD.SET_USERS',
 
  LIST_REQUESTING: 'USERAD.LIST_REQUESTING',
  LIST_SUCCESS: 'USERAD.LIST_SUCCESS',
  LIST_ERROR: 'USERAD.LIST_ERROR',  
    
  ITEM_REQUESTING: 'USERAD.ITEM_REQUESTING',
  ITEM_SUCCESS: 'USERAD.ITEM_SUCCESS',
  ITEM_ERROR: 'USERAD.ITEM_ERROR',  
    
  ITEM_ADD_REQUESTING: 'USERAD.ITEM_ADD_REQUESTING',
  ITEM_ADD_SUCCESS: 'USERAD.ITEM_ADD_SUCCESS',
  ITEM_ADD_ERROR: 'USERAD.ITEM_ADD_ERROR',  
    
  ITEM_UPDATE_REQUESTING: 'USERAD.ITEM_UPDATE_REQUESTING',
  ITEM_UPDATE_SUCCESS: 'USERAD.ITEM_UPDATE_SUCCESS',
  ITEM_UPDATE_ERROR: 'USERAD.ITEM_UPDATE_ERROR',  
    
  ITEM_REMOVE_REQUESTING: 'USERAD.ITEM_REMOVE_REQUESTING',  
  ITEM_REMOVE_SUCCESS:  'USERAD.ITEM_REMOVE_SUCCESS',  
  ITEM_REMOVE_ERROR:  'USERAD.ITEM_REMOVE_ERROR',  

  RESET_DATA: 'USERAD.RESET_DATA',
  SET_MESSAGE: 'USERAD.SET_MESSAGE',
  RESET_ERROR: 'USERAD.RESET_ERROR',
  SET_ERROR: 'USERAD.SET_ERROR',
  SET_FORM_MESSAGES: 'USERAD.SET_FORM_MESSAGES',
  SET_DATA_TO_USER:  'USERAD.SET_DATA_TO_USER',
  SET_DATA_TO_PROPS:  'USERAD.SET_DATA_TO_PROPS',

  LIST_API: '/api/v2/admin/list_users_ad_by_store',
  ITEM_ADD_API: '/api/v2/admin/addUsersAd',
  
  ITEM_API: '/api/v2/admin/user_detailsAd',

  ITEM_UPDATE_API: '/api/v2/admin/user_updateAd',
  
  ITEM_REMOVE_API: '/api/v1/admin/user_delete',
  LOAD_USERS_API: '/api/v2/admin/list_users_ad_by_store',
};

export default UserAdTypes;


// WEBPACK FOOTER //
// ./src/views/Admin/UserAd/constants.js